<template>
  <div class="home-page">
    <div class="header-info">
      <div class="weicome-info">
        <span class="hello-name txt-ellipsis" v-if="userInfo.user">Hi~ {{ userInfo.user.nickName }}</span>
        <div class="header-right-info">
          <div class="market-insight" @click="toPage('/marketInsight', { auth: 'app:user:surveyInput' })">
            <img src="@/assets/images/market_insight.png" class="insight-icon" alt="">
            <span class="txt-ellipsis">{{ $t('shared.title.marketInsight') }}</span>
          </div>
          <div class="user-img" @click="$router.push('/user')">
            <!-- <img src="@/assets/images/user_date.png" alt="" class="date-icon" > -->
            <img src="@/assets/images/user_img.png" alt="" class="user-icon">
          </div>
        </div>
      </div>
      <div class="weicome-message">{{ $t('shared.title.pleaseSelectYourWorkItems') }}:</div>
      <div class="menu-grid">
        <div v-for="(item, index) in menuItems" :key="index" class="menu-item" :style="{ width: menuItems.length % 2 !== 0 && index === menuItems.length - 1 ? '100%' : '49%' }" @click="toPage(item.toUrl, item)">
          <div class="left-desc">
            <span class="menu-text">
              <span v-if="['/storeExpansion', '/storeMaintain'].includes(item.path)" class="sub-title">Store</span>
              <span>{{ item.text }}</span>
            </span>
            <!-- <span class="tips-text">{{ item.tips }}</span> -->
          </div>
          <img :src="item.icon" alt="" :class="`font-icon font-img${index}`">
        </div>
      </div>
    </div>
    <!--  -->
    <div class="middle-section">
      <div class="supervised-matters">
        <div class="title-txt">
          <!-- 督办事项 -->
          <span>{{ $t('shared.title.oversightMatters') }}</span>
          <van-icon name="info-o" class="info-icon" @click="handleTips" />
        </div>
        <div class="matters-info">
          <div v-for="subItem in mattersList" :key="subItem.field" class="matters-item" :class="{'matters-custom-item': mattersList.length % 2 !==  0}" @click="toPage(subItem.path, subItem)">
            <span v-if="['stayAllotCount'].includes(subItem.field) && !checkPer(['admin', subItem.auth])" class="matters-num">0</span>
            <span v-else class="matters-num">{{ mattersInfo[subItem.field] }}</span>
            <span>{{ subItem.label }}</span>
          </div>
        </div>
      </div>
      <div class="split-line"></div>
      <div class="schedule-content">
        <div class="title">
          <span class="left-text">{{ $t('shared.title.mySchedule') }}</span>
          <span @click="toPage('/schedule')">{{ $t('shared.more') }} <van-icon name="arrow" class="card-arrow" /></span>
        </div>
        <div v-if="homeList.length > 0" class="schedule-info">
          <van-steps class="steps-content" direction="vertical">
            <van-step v-for="item in homeList" :key="item.id">
              <div slot="active-icon" style="width: 9px; height: 9px; border: 1px solid #307bff; border-radius: 50%; background-color: #fff;"></div>
              <div slot="inactive-icon" style="width: 9px; height: 9px; border: 1px solid #307bff; border-radius: 50%; background-color: #fff;"></div>
              <div class="step-title" @click="toPath(item)">
                <span>{{ item.newScheduleTime }}</span>
                <!-- <span class="project-name">{{ item.scheduleType === 1 ? $t('form.popUp') : item.scheduleType === 2 ? `${globalData.brandName} day` : item.scheduleType === 3 ? `Visit` : '' }}</span> -->
                <span class="project-name">{{ item.scheduleType === 1 ? $t('form.popUp') : item.scheduleType === 2 ? $t('form.brandDay') : item.scheduleType === 3 ? $t('shared.visit') : '' }}</span>
              </div>
              <div class="step-content" @click="toPath(item)">
                <div class="step-item" v-for="(stepItem, stepIndex) in item.detailList" :key="stepIndex">
                  <img v-if="stepItem.targetType === 1" src="@/assets/images/sd.png" class="row-icon" />
                  <img v-else src="@/assets/images/store.png" class="row-icon" />
                  <span class="store-name txt-ellipsis">{{ stepItem.targetName }}</span>
                  <img class="nav-path-img" src="@/assets/images/daohan1.png" alt="" @click.stop="goToVisit(item)">
                </div>
              </div>
              <div v-if="item.detailListTotal >= 4">
                {{ $t('form.total') }}：<span style="color: #307bff;">{{ item.customerCount }} {{ $t('shared.stores') }}, {{ item.sdCount }} {{ $t('shared.distributors') }}</span>
              </div>
            </van-step>
            <van-step></van-step>
          </van-steps>
        </div>
        <van-empty v-else :description="$t('tips.noData')" />
      </div>
    </div>
    <div class="split-line"></div>
    <div class="view-content">
      <!-- 快捷入口 -->
      <div class="view-title">{{ $t('shared.title.quickEntrance') }}</div>
      <div class="view-section">
        <div v-for="subItem in quickAaccessList" :key="subItem.label" class="section-item" @click="toPage(subItem.path, subItem)">
          <img class="store-icon-img" :src="subItem.imgIcon" alt="">
          <!-- 我的审批 -->
          <span v-if="subItem.label !== 'My approval'" class="item-name">{{ subItem.label }}</span>
          <van-badge v-else :content="5" max="99">
            <span class="item-name">{{ subItem.label }}</span>
          </van-badge>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { arsAppHomeApi, arsProductListApi } from '@/api/home'
import { arsProjectAppQueryListApi } from '@/api/storeMaintain'
import { Toast, Dialog } from 'vant'
import { mapState, mapMutations } from 'vuex'
import { formatScheduleTime } from '@/utils/date'
import loadGoogleMaps from '@/utils/google-maps-loader'
var geocoder = null
export default {
  name: 'HomePage',
  data () {
    return {
      homeList: [],
      currentAddres: '',
      mattersInfo: {
        auditCount: 0,
        stayAllotCount: 0,
        overdueVisitCount: 0,
        stayEventCount: 0
      }
    }
  },
  activated () {
    this.getHomeData()
  },
  deactivated () {
    this.$destroy()
  },
  computed: {
    ...mapState({
      globalData: 'globalData',
      userInfo: 'myUserInfo'
    }),
    menuItems () {
      const menusList = []
      if (this.checkPer(['admin', 'app:expandCustomer'])) {
        menusList.push({
          // 门店拓展
          text: this.$t('shared.development'),
          icon: require('@/assets/images/mapping_img.png'),
          path: '/storeExpansion',
          toUrl: '/storeExpansion',
          tips: this.$t('shared.theFirstSaleOrInvitation'), // 首次卖进or活动邀约
          auth: 'app:expandCustomer'
        })
      }
      if (this.checkPer(['admin', 'app:customer'])) {
        menusList.push({
          // 门店维护
          text: this.$t('shared.operation'),
          icon: require('@/assets/images/visit_img.png'),
          path: '/storeMaintain', // '/plan',
          toUrl: '/storeMaintain', // '/plan'
          tips: 'xxxxxxxx',
          auth: 'app:customer'
        })
      }
      if (this.checkPer(['admin', 'app:sd'])) {
        menusList.push({
          text: this.$t('shared.distributor'),
          icon: require('@/assets/images/sd_icon.png'),
          path: '/salesDistribution', // '/plan',
          toUrl: '/salesDistribution', // '/plan'
          tips: 'xxxxxxxx',
          auth: 'app:sd'
        })
      }
      // menusList.push({
      //   text: 'Event',
      //   icon: require('@/assets/images/event_img.png'),
      //   path: '/event',
      //   toUrl: '/event'
      // })
      // menusList.push({
      //   text: 'Incentive',
      //   icon: require('@/assets/images/incentive_img.png'),
      //   path: '/incentive', // '/plan',
      //   toUrl: '/incentive' // '/plan'
      // })
      return menusList
    },
    mattersList () {
      const arrList = []
      // 待分配
      if (this.checkPer(['admin', 'app:expandCustomer:allot'])) {
        arrList.push({ label: this.$t('shared.toBeAllocated'), field: 'stayAllotCount', path: '/unassignedStore', auth: 'app:expandCustomer:allot' })
      }
      if (this.checkPer(['admin', 'app:audit'])) {
        arrList.push({ label: this.$t('shared.kickOutOfOperation'), field: 'auditCount', path: '/pendingRevies', auth: 'app:audit' })
      }
      // 逾期未跟进
      arrList.push({ label: this.$t('shared.overdueFollowUp'), field: 'overdueVisitCount', path: '/overdueNoFollowed', auth: '' })
      // 待举办活动
      arrList.push({ label: this.$t('shared.anEventToBeHeld'), field: 'stayEventCount', path: '/pendingEventStore', auth: '' })
      return arrList
    },
    quickAaccessList () {
      const arrList = [
        { label: this.$t('shared.event'), imgIcon: require('@/assets/images/event_index.png'), path: '/event', auth: 'app:event' },
        // { label: 'Incentive', imgIcon: require('@/assets/images/incentive_index.png'), path: '/incentive', auth: 'app:incentive' },
        { label: this.$t('shared.visitPlan'), imgIcon: require('@/assets/images/event_index.png'), path: '/visitPlan', auth: 'app:event' }
      ]
      return arrList
    }
  },
  methods: {
    ...mapMutations('event', ['SET_EVENTINFO']),
    ...mapMutations(['setGlobalData']),
    toPage (toUrl, params) {
      if (!toUrl) {
        Toast(this.$t('tips.stayTuned'))
        return
      }
      if (params && params.auth && !this.checkPer(['admin', params.auth])) {
        Toast(this.$t('tips.noPermissionYet'))
        return
      }
      // if (!toUrl) {
      //   Toast('Function not yet open')
      //   return
      // }
      this.$router.push(toUrl)
    },
    getHomeData () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      arsAppHomeApi().then(res => {
        Toast.clear()
        res.data.scheduleList.forEach(subItem => {
          subItem.newScheduleTime = formatScheduleTime(subItem.scheduleTime)
          subItem.detailListTotal = subItem.detailList.length
          subItem.detailList = subItem.detailList.filter((detItem, detIndex) => {
            if (detIndex < 3) {
              return detItem
            }
          })
        })
        Object.keys(this.mattersInfo).forEach(subItem => {
          this.mattersInfo[subItem] = res.data[subItem]
        })
        this.homeList = res.data.scheduleList || []
      }).catch(() => {
        this.homeList = []
      })
      arsProjectAppQueryListApi().then(res => {
        this.setGlobalData([{ key: 'brandProductList', val: res.data }])
      })
      arsProductListApi().then(res => {
        this.setGlobalData([{ key: 'productList', val: res.data }])
      })
      this.$nextTick(async () => {
        const currentTimeLoc = JSON.parse(localStorage.getItem('currentTimeLoc'))
        if (currentTimeLoc) {
          const maps = await loadGoogleMaps()
          geocoder = new maps.Geocoder()
          this.getlocation(currentTimeLoc.lat, currentTimeLoc.lng)
        }
      })
    },
    goToVisit (params) {
      if (!params.address) return
      window.location.href = `https://www.google.com/maps/dir/?api=1&dir_action=navigate&origin=${this.currentAddres}&destination=${params.address}`
    },
    toPath (params) {
      if (params.scheduleType === 3) {
        this.$router.push(`/visitPlan/detail?planId=${params.sourceId}`)
      } else {
        this.SET_EVENTINFO({ eventId: params.sourceId, schedule: '' })
        this.$router.push(`/eventDetail?eventId=${params.sourceId}&pageType=`)
      }
    },
    getlocation (lat, lng) {
      const $that = this
      // 根据经纬度获取位置
      geocoder.geocode(
        {
          location: new google.maps.LatLng(lat, lng)
        },
        function geoResults (results, status) {
          Toast.clear()
          // 这里处理结果和上面一模一样
          if (status == google.maps.GeocoderStatus.OK) {
            $that.currentAddres = results[0].formatted_address
          } else {
            console.log('：error ' + status)
          }
        }
      )
    },
    handleTips () {
      Dialog.alert({
        // message: '1、待分配：提交拜访「拓展组门店池」中的门店，且拜访记录中至少有1个产品上架，系统将自动推送1条「待分配门店」的记录，零售负责人可将该门店转移并分配到指定人，由其开展后续跟进与维护工作。\n\n 2、逾期未跟进：根据业务管理指标，对核心/待验证门店分别设置对应跟进的频率，若超过预设间隔未跟进，将进行预警督办。\n\n 3、待举办活动：门店新分配至员工时，若该门店有event邀约记录，员工需在规定时间内完成event提报并上传执行情况。',
        message: `1. ${this.$t('tips.messageSixteen')}\n\n 2. ${this.$t('tips.messageSeventeen')}\n\n 3. ${this.$t('tips.messgaeEighteen')}\n\n 4. ${this.$t('tips.messageNineteen')}`,
        confirmButtonText: this.$t('button.gotIt'),
        messageAlign: 'left',
        confirmButtonColor: '#307bff'
      }).then(() => {
        // on close
      })
    }
  }
}
</script>

<style lang="less" scoped>
.home-page {
  height: 100%;
  background-color: #f5f5f9;
  .header-info {
    padding: 20px 10px;
    padding-top: 30px;
    background-color: #307bff;
    color: #fff;
    .weicome-info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 8px;
      font-size: 18px;
      font-weight: bold;
      .hello-name {
        width: 166px;
      }
      .header-right-info {
        display: flex;
        align-items: center;
        .market-insight {
          display: flex;
          align-items: center;
          padding: 5px 10px;
          border-radius: 8px;
          color: #307bff;
          font-size: 12px;
          background-color: #fff;
          font-weight: 400;
          >span {
            max-width: 103px;
          }
        }
        .user-img {
          display: flex;
          align-items: center;
          .user-icon {
            width: 30px;
            height: 30px;
            margin-left: 5px;
          }
          .date-icon {
            width: 26px;
            height: 26px;
            margin-left: 5px;
          }
        }
      }
      .insight-icon {
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }
    }
    .menu-grid {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 10px 0px 5px 0px;
      background-color: #307bff;
      .menu-item {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 49%;
        min-height: 83px;
        padding: 0 10px;
        border-radius: 13px;
        // background-color: #e6f4fe;
        background: linear-gradient(to bottom right, #ffffff 50%, #307bff 200%);
        // box-shadow: 4px 5px rgba(230, 244, 254, 0.5);
        margin-bottom: 10px;
        .font-icon {
          position: absolute;
          right: 10px;
          width: 36px;
          height: 36px;
        }
        .menu-text {
          display: flex;
          flex-direction: column;
          font-size: 18px;
          font-weight: bold;
          word-break: break-word;
          .sub-title {
            margin-bottom: 5px;
            font-size: 12px;
            font-weight: 400;
          }
        }
        .left-desc {
          width: 100%;
          display: flex;
          flex-direction: column;
          color: #307bff;
          z-index: 1;
          .tips-text {
            font-size: 10px;
            margin-top: 8px;
          }
        }
      }
    }
  }
  .middle-section {
    padding: 10px 0;
    margin-top: -20px;
    background-color: #fff;
    border-top-left-radius: 13px;
    border-top-right-radius: 13px;
    .supervised-matters {
      padding: 0 10px;
      .title-txt {
        display: flex;
        align-items: center;
        >span {
          font-weight: bold;
          font-size: 18px;
          margin-right: 6px;
        }
        .info-icon {
          color: #333;
          font-size: 14px;
        }
      }
      .matters-info {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .matters-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 50%;
          padding: 10px 5px;
          font-size: 11px;
          color: #333;
          .matters-num {
            color: #307bff;
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 6px;
          }
        }
        .matters-custom-item {
          width: 33%;
        }
      }
    }
    .schedule-content {
      padding: 0 10px;
      padding-top: 10px;
      .title {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
        .left-text {
          font-size: 16px;
          font-weight: bold;
        }
      }
      .schedule-info {
        .steps-content {
          font-size: 11px;
          .step-title {
            display: flex;
            align-items: center;
            margin-bottom: 6px;
            font-size: 14px;
            font-weight: bold;
            .project-name {
              padding: 0px 3px;
              margin-left: 5px;
              font-size: 11px;
              font-weight: 400;
              color: #307bff;
              border: 1px solid #307bff;
              background-color: #e8effc;
              line-height: 15px;
            }
          }

          .step-item {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            .row-icon {
              width: 16px;
              height: 16px;
              margin-top: 4px;
              object-fit: contain;
            }
            > span {
              margin-left: 5px;
              padding-top: 4px;
            }
            .nav-path-img {
              width: 20px;
              height: 20px;
            }
            .store-name {
              flex: 1;
              font-size: 14px;
            }
          }
          /deep/.van-step {
            color: #000;
          }
          /deep/.van-step--vertical {
            padding-top: 5px;
            padding-bottom: 5px;
            padding-right: 0;
            &:first-child {
              padding-top: 5px;
            }

            font-size: 11px;
            &:last-child {
              .van-step__circle {
                display: none;
              }
            }
            .van-step__icon--active {
              color: #307bff;
            }
            .van-step__title--active,
            .van-step__icon--finish,
            .van-step__title--finish {
              color: #000;
            }
            &::after {
              border: none;
            }
            .van-step__circle-container {
              top: 15px;
            }
          }
        }
        /deep/.van-steps--vertical {
          padding: 0 0 0 21px;
          .van-step__circle,
          .van-step__line {
            background-color: #307bff;
          }
          .van-step__line {
            left: -16px;
          }
          .van-step__circle {
            width: 8px;
            height: 8px;
          }
        }
        .too-mini-img {
          width: 10px;
          height: 10px;
          margin-top: 3px;
        }
      }
      /deep/.van-empty {
        padding: 10px 0;
      }
    }
  }
  .split-line {
    height: 4px;
    background-color: #f5f5f9;
  }
  .view-content {
    padding: 10px;
    background-color: #fff;
    .view-title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .view-section {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .section-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 49%;
        padding: 15px;
        border: 1px solid #307bff;
        border-radius: 10px;
        margin-bottom: 8px;
        .item-name {
          font-size: 13px;
          color: #333;
        }
        /deep/.van-badge--fixed {
          right: -5px;
        }
      }
    }
    .store-icon-img {
      width: 30px;
      height: 30px;
      margin-bottom: 8px;
    }
  }
}
</style>
